import { useContext } from 'react'
import { RestContext } from './context'

export const useRest = () => {
  return useContext(RestContext);
}